import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ service, index = 0 }) {
  return (
    <Link
      to={`/services/${service.slug}`}
      className="lux-card group block overflow-hidden"
      data-testid={`service-card-${service.slug}`}
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={service.hero}
          alt={service.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <span className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase text-white/70">
          0{index + 1}
        </span>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-display text-xl text-white leading-snug">{service.name}</h3>
          <ArrowUpRight size={20} className="text-white/40 group-hover:text-[#9B1B30] transition-colors" />
        </div>
        <p className="text-sm text-white/60 mt-2 leading-relaxed">{service.short}</p>
      </div>
    </Link>
  );
}
